var Anhui = "安徽";
var Beijing = "北京";
var Chongqing = "重慶";
var Fujian = "福建";
var Gansu = "甘肅";
var Guangdong = "廣東";
var Guangxi = "廣西";
var Guizhou = "貴州";
var Hainan = "海南";
var Hebei = "河北";
var Heilongjiang = "黑龍江";
var Henan = "河南";
var Hubei = "湖北";
var Hunan = "湖南";
var Jiangsu = "江蘇";
var Jiangxi = "江西";
var Jilin = "吉林";
var Liaoning = "遼寧";
var Ningxia = "寧夏";
var Qinghai = "青海";
var Shaanxi = "陜西";
var Shandong = "山東";
var Shanghai = "上海";
var Shanxi = "山西";
var Sichuan = "四川";
var Tianjin = "天津";
var Tibet = "西藏自治區";
var Xinjiang = "新疆";
var Yunnan = "雲南";
var Zhejiang = "浙江";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "內蒙古自治區",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
